module.exports = __webpack_public_path__ + "static/media/1.00f42ba9.jpg";